import "./style.css";
import { runApp } from "./app";

const root = document.getElementById("app");
if (root) {
  void runApp(root);
}
